<template>
  <div :class="['chat-container', 'd--f', 'fd--c', 'bg-white', 'br-10px', { 'chat-container--overlay': overlay }]">
    <ChatHeader :show-close-button="overlay" @close="$emit('close')" />

    <ChatMessages :messages="messages" :loading="loading" />

    <ChatInput @send-message="sendMessage" :disabled="loading" />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRoute } from "vue-router";

import { useConversation } from "@/composables/useConversation";
import ChatHeader from "@/views/ReportDetailsView/components/ReportChat/ChatHeader.vue";
import ChatMessages from "@/views/ReportDetailsView/components/ReportChat/ChatMessages.vue";
import ChatInput from "@/views/ReportDetailsView/components/ReportChat/ChatInput.vue";

defineProps({
  overlay: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["close"]);

const route = useRoute();
const reportId = route.params.id;

const { messages, loading, fetchConversation, sendMessage } = useConversation(reportId);

onMounted(() => {
  fetchConversation();
});
</script>

<style lang="scss" scoped>
.chat-container {
  width: 360px;
  flex-shrink: 0;
  position: sticky;
  top: 130px;
  height: calc(100vh - 160px);
  align-self: flex-start;

  &--overlay {
    width: 100%;
    height: 100%;
    min-height: 0;
    position: static;
    flex-shrink: 1;
    align-self: stretch;
  }
}
</style>
